import React from "react";
import axios from "axios";
import params from "../params";
import Dim from "./Dim";
import Requests from "../utils/requests";

export default class LevelModalWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = { active: false, item: null, records: [] };
        LevelModalWindow.modal = this;
    }
    
    render() {
        const { active, item, records } = this.state;
    
        return (
            <div className={`level-modal-window ${active ? 'active' : ''}`}>
                <h3>{item ? item.name : ''}</h3>
                <p className="victors">
                    {
                        records.length > 0 ? records.map((e, index) => {
                            return <a href={e.url} target="_blank" key={index}>{index + 1}. {e.userName}</a>
                        }) : null
                    }
                </p>
            </div>
        );
    }

    static getWindow(item) {
        LevelModalWindow.setData(item);
        Dim.openDim();
    }

    static closeWindow() {
        const modal = LevelModalWindow.modal;
        if(modal) modal.setState({ active: false }); // , records: [], item: null
    }

    static async setData(item) {
        const modal = LevelModalWindow.modal;

        if(!modal) return;

        try {
            let r;
            if(params.server) {
                r = await axios.post(params.apiUrl + '/demonlist/getRecords.php', {
                    lvlid: item.id
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                });
            } else {
                r = await Requests.getRecords(item.id);
            }
            const lines = r.data.split('\n');
            const records = [];

            for(let i = 0; i < lines.length; i++) {
                if(!lines[i]) continue;

                const params = lines[i].split(';');
                if(params[1] != item.id) continue;

                records.push({ userName: params[0], url: params[3] });
            }

            modal.setState({ active: true, item: item, records: records });
        } catch(e) {
            throw new Error(e.message);
        }
    }
}